<template>
  <span
    v-if="hasHint"
    :class="structure['hint']"
  >
    <Tooltip
      :content="hint"
      :label="$t('common.fields.moreInfo', { label })"
    >
      <template #icon>
        <InformationCircleIcon
          class="size-4"
          aria-hidden="true"
        />
      </template>
    </Tooltip>
  </span>

  <span
    v-if="hasAside"
    :class="structure['aside']"
  >
    <slot />
  </span>
</template>

<script setup lang="ts">
import { InformationCircleIcon } from '@heroicons/vue/20/solid'
import { computed, useSlots } from 'vue'

import Tooltip from '../../atoms/Tooltip/Tooltip.atom.vue'

import structure from './FieldHelp.structure.module.css'

const props = withDefaults(
  defineProps<{
    /** Field label text; names the info icon. */
    label: string
    /** Non-empty renders an info icon right of the label that reveals this copy. */
    hint?: string
  }>(),
  { hint: '' }
)

defineSlots<{
  /** Trailing content at the end of the label row, e.g. a counter or state indicator. */
  default?: () => unknown
}>()

const slots = useSlots()

const hasHint = computed(() => props.hint !== '')
const hasAside = computed(() => slots['default'] !== undefined)
</script>
